import { ManualGroups } from '@/modules/listGroupFeed/domain/models/GetManualGroups'

import { axios, Response } from '..'

const getPermissionManual = (): Response<ManualGroups[]> => {
  return axios.get(`/v1/automation-groups-manual`)
}
export default getPermissionManual
